




import { Component, Prop, Vue } from 'vue-property-decorator';
import { quillEditor } from 'vue-quill-editor';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';

@Component({
  components: { quillEditor }
})
export default class EmailRichEditor extends Vue {
  @Prop({ default: '' }) value!: string;
  @Prop({ default: '请输入邮件正文' }) placeholder!: string;

  // 邮件正文编辑器: 只保留基础富文本格式, 不支持图片/附件/视频
  editorOptions = {
    placeholder: this.placeholder,
    modules: {
      toolbar: [
        [{ header: [1, 2, 3, false] }],
        ['bold', 'italic', 'underline', 'strike'],
        [{ color: [] }, { background: [] }],
        [{ list: 'ordered' }, { list: 'bullet' }],
        ['blockquote', 'code-block'],
        ['link', 'clean']
      ]
    }
  };

  get content() {
    return this.value;
  }

  set content(html: string) {
    this.$emit('input', html);
  }
}
